import { useCallback, useRef } from 'react'

import { usePathname } from 'next/navigation'

import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider'

import { HEADER_BANNER_HEIGHT } from './constants'

export const useDisableBodyScroll = (enabled = false) => {
    const { isMobile } = useMobileDetect()
    const pathname = usePathname()
    const isInProfilePages = pathname.includes('/profile')

    const shouldDisableScroll = enabled && isMobile
    const scrollPositionRef = useRef<number>()

    const disableScroll = useCallback(() => {
        if (!shouldDisableScroll) return

        const currentScroll = typeof window !== 'undefined' ? window?.scrollY : 0

        scrollPositionRef.current = currentScroll

        const body = document.body
        body.style.top = `-${currentScroll}px`
        body.style.overflow = 'hidden'
        body.style.position = 'fixed'
        body.style.width = '100%'

        if (isInProfilePages) {
            const profileHeader = document.getElementById('profile-header')
            profileHeader && (profileHeader.style.position = 'fixed')

            const profileHeaderMarginBottom = profileHeader ? parseInt(getComputedStyle(profileHeader).marginBottom) : 0
            const profileHeaderHeight = (profileHeader?.offsetHeight || 0) + profileHeaderMarginBottom

            body.style.paddingTop = `${profileHeaderHeight}px`
        } else if (currentScroll > HEADER_BANNER_HEIGHT) {
            const header = document.getElementById('header')
            header && (header.style.position = 'fixed')

            body.style.paddingTop = `${header?.offsetHeight || 0}px`
        }
    }, [isInProfilePages, shouldDisableScroll])

    const enableScroll = useCallback(() => {
        if (!shouldDisableScroll) return

        const body = document.body

        body.style.paddingTop = ''
        body.style.top = ''
        body.style.overflow = ''
        body.style.position = ''
        body.style.width = ''

        const header = document.getElementById('header')
        header && (header.style.position = '')

        if (isInProfilePages) {
            const profileHeader = document.getElementById('profile-header')
            profileHeader && (profileHeader.style.position = '')
        }

        if (typeof window === 'undefined' || !scrollPositionRef.current) return

        setTimeout(() => window.scrollTo({ top: scrollPositionRef.current }))
    }, [isInProfilePages, shouldDisableScroll])

    return { shouldDisableScroll, disableScroll, enableScroll }
}
